import React, {useContext, useState, useEffect} from 'react'
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {UALContext} from "ual-reactjs-renderer";

import OrangeBorderButton from "../OrangeBorderButton/OrangeBorderButton";
import OrangeButton from "../OrangeButton/OrangeButton";

import Logo from '../../images/logo.png'
import TokenLogo from '../../images/logo@2x.png'
import LogOut from '../../images/logout.png'

import './Header.scss';

import {getCollectionsSearch} from "../../services/wax.services";



function Header({balance}) {
    const { activeUser, showModal, logout } = useContext(UALContext);
    const allCollections = useSelector(state => state.allCollections)
    const [searchText, setSearchText] = useState('');
    const [filteredCollections, setFilteredCollections] = useState([])
    const [burgerOpen, setBurgerOpen] = useState(false)


    useEffect(() => {
        if (searchText.length > 3) {
            getCollectionsSearch(searchText)
                .then((data) => {
                    setFilteredCollections(data);
                })
                .catch((e) => console.log(e));
        }
    }, [searchText]);
    
    const handleConnect = () => {
        showModal()
    }

    const handleLogOut = () => {
        logout()
    }

    // const handleSearchInputChange = (event) => {
    //     setSearchText(event.target.value);
    //     const filteredCollections = allCollections.filter((collection) => {
    //         return collection.collection_name.toLowerCase().includes(event.target.value.toLowerCase());
    //     });
    //     setFilteredCollections(filteredCollections);
    // };

    const handleSearchInputChange = (event) => {
        setSearchText(event.target.value);
    };
    //
    // function handletest() {
    //     toast.success('🦄 Wow so easy!', {
    //         position: "bottom-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "light",
    //     });
    // }
    
    const openAncor = () => {
        window.open("https://wax.alcor.exchange/trade/alch-alchemyswapy_wax-eosio.token", "_blank");
    }

    return (
        <header className="header">
            <div className="header-container">
                <div className="header-left">
                    <Link to={'/'}>
                        <div className="header-left_logo">
                            <img src={Logo} alt=""/>
                        </div>
                    </Link>
                    <div className="header-left_search">
                        <input type="text" placeholder={'Search collections'} onChange={handleSearchInputChange} value={searchText}/>
                        {searchText.length > 2 && (
                            <ul className="header-left_search-results">
                                {filteredCollections.map((collection, index) => (
                                    <Link to={`/collections/${collection.collection_name}`}>
                                        <li onClick={() => setSearchText('')} key={index}>{collection.collection_name}</li>
                                    </Link>
                                ))}
                            </ul>
                        )}
                        <Link to={'/collections'}>
                            <OrangeBorderButton width={136} link={'/collections'}>Collections</OrangeBorderButton>
                        </Link>
                        <Link to={'/pools'}>
                            <OrangeBorderButton width={136} link={'/pools'}>All Pools</OrangeBorderButton>
                        </Link>
                    </div>
                </div>
                <div className="header-right">
                    <div className="header-right_logIn">
                        {activeUser &&
                            <div className={'token-block'} onClick={() => openAncor()}>
                                <div className="token-icon">
                                    <img src={TokenLogo} alt=""/>
                                </div>
                                <div className="token-amount">
                                    <p>{balance}</p>
                                </div>
                            </div>
                        }
                        {/*<OrangeBorderButton>Your NFTs</OrangeBorderButton>*/}
                        <OrangeBorderButton link={'/pool'}>Your Pools</OrangeBorderButton>
                        {!activeUser ?
                            <OrangeButton onClick={handleConnect}>Connect</OrangeButton>
                            :
                            <div className={'user-block'}>
                                <div className="avatar" onClick={handleLogOut}></div>
                                <div className="user-name">
                                    <p>{activeUser.accountName}</p>
                                </div>
                                <div className="arrow"></div>
                            </div>
                        }
                    </div>
                    {/*<div className="header-right_cart">*/}
                    {/*    <img src={CartIcon} alt=""/>*/}
                    {/*</div>*/}
                </div>
            </div>
            <div className="header-container-mobile">
                {burgerOpen ?
                    <div className="burger-menu" onClick={() => setBurgerOpen(!burgerOpen)}>
                        <p> > </p>
                    </div>
                    :
                    <div className="burger-menu" onClick={() => setBurgerOpen(!burgerOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                }


                <div className="header-left_logo">
                    <Link to={'/'}>
                        <img src={Logo} alt=""/>
                    </Link>
                </div>

                {!activeUser ?
                    <OrangeButton className={'connect-for-mobile'} onClick={handleConnect}>Connect</OrangeButton>
                    :
                    <div className={'user-block'}>
                        <div className="avatar" onClick={handleLogOut}></div>
                        <div className="user-name">
                            <p>{activeUser.accountName}</p>
                        </div>
                        <div className="arrow"></div>
                    </div>
                }

                {burgerOpen ?
                    <div className={'burger-menu-content'}>
                        <div className="burger-menu-content_wrapper">
                                <OrangeBorderButton onClick={() => setBurgerOpen(false)} link={'/collections'} className={'burger-menu-content_wrapper-btn'} width={626} height={72}>Collections</OrangeBorderButton>
                                <OrangeBorderButton onClick={() => setBurgerOpen(false)} link={'/pools'} className={'burger-menu-content_wrapper-btn'} width={626} height={72}>All Pools</OrangeBorderButton>
                                <OrangeBorderButton onClick={() => setBurgerOpen(false)} link={'/pool'} className={'burger-menu-content_wrapper-btn'} width={626} height={72}>Your Pools</OrangeBorderButton>
                                <OrangeBorderButton className={'burger-menu-content_wrapper-btn'} width={626} height={72} onClick={() => logout()}>
                                    <div className="logout-burger">
                                        <img src={LogOut} alt=""/>
                                        <p>Logout</p>
                                    </div>
                                </OrangeBorderButton>
                        </div>
                    </div>
                    :
                    false
                }
            </div>
        </header>
    );
}

export default Header;
